import { translate } from "@kaltura/mediaspace-shared-utils";
import { Time24Icon } from "@kaltura/ds-react-icons";
import { Status } from "@kaltura/ds-react-components";

export const OutOfScheduleStatus = () => {
    return <Status icon={<Time24Icon color={"inherit"} />} label={translate("Out of schedule")} />;
};
